import type { ReactNode } from "react";
import { useCallback, useState } from "react";
import { CreateEstimationContext } from "./create-estimation-context";

interface CreateEstimationProviderProps {
  children: ReactNode;
}

export const CreateEstimationProvider = ({ children }: CreateEstimationProviderProps) => {
  const [showNewEstimationModal, setShowNewEstimationModal] = useState(false);

  const toggleShowNewEstimationModal = useCallback(() => {
    setShowNewEstimationModal((prev) => !prev);
  }, []);

  return (
    <CreateEstimationContext.Provider
      value={{
        showNewEstimationModal,
        toggleShowNewEstimationModal,
      }}
    >
      {children}
    </CreateEstimationContext.Provider>
  );
};
